<template>
	<div>
		<div class="heared">
			<div>
				发布数量: <span>{{ statistics_data.total_join || 0 }}</span>
			</div>
			<div>
				播放数量: <span>{{ statistics_data.total_play || 0 }}</span>
			</div>
			<div>
				点赞数量: <span>{{ statistics_data.total_like || 0 }}</span>
			</div>
			<div>
				评论数量: <span>{{ statistics_data.total_comment || 0 }}</span>
			</div>
			<div>
				分享数量: <span>{{ statistics_data.total_share || 0 }}</span>
			</div>
		</div>
		<div class="list">
			<h2>抖音播放列表</h2>
			<el-table :data="tableData.data" style="width: 100%">
				<el-table-column prop="activity_id" label="活动ID"> </el-table-column>
				<el-table-column prop="nickname" label="昵称"> </el-table-column>
				<el-table-column prop="avatar" label="头像">
					<template slot-scope="scope">
						<el-image
							style="width: 50px; height: 50px"
							:src="scope.row.avatar"
							fit="cover"
						></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="mobile" label="手机号"> </el-table-column>
				<el-table-column prop="like" label="点赞数量"> </el-table-column>
				<el-table-column prop="play" label="播放数量"> </el-table-column>
				<el-table-column prop="comment" label="评论数量"> </el-table-column>
				<el-table-column prop="share" label="分享数量"> </el-table-column>
				<!-- <el-table-column prop="reward" label="奖励详情">
					<template slot-scope="scope">
						<div class="awards">
							<p v-for="(item, index) in scope.row.products" :key="index">
								{{ item.item_name }}*{{ item.num }}
							</p>
						</div>
					</template>
				</el-table-column> -->
				<el-table-column prop="create_time" label="创建时间"> </el-table-column>
			</el-table>
			<el-pagination
				style="margin-top: 20px;margin-bottom: 50px;float: right;"
				background
				layout="prev, pager, next"
				:total="tableData.total"
        :page-size='5'
				@current-change="current_page"
			>
			</el-pagination>
		</div>
	</div>
</template>
<script>
import { Dy_PlayList, Dy_statistics } from "@/api/Douyin";
import { mapGetters } from "vuex";
export default {
	computed: {
		...mapGetters(["token", "app_id"]),
	},
	data() {
		return {
			page_count: 1,
			tableData: {},
			page: 1,
			statistics_data: {},
		};
	},
	mounted() {
		this.list();
		this.statistics();
	},
	methods: {
		current_page(val) {
			this.page = val;
			this.list();
		},
		async list() {
			try {
				const res = await Dy_PlayList({
					app_id: this.app_id,
					activity_id: this.$route.query.id,
					limit: 5,
					page: this.page,
				});
				this.tableData = res.data;
				this.page_count = res.data.total / 5;
			} catch (e) {
				console.log(e);
			}
		},
		async statistics() {
			try {
				const res = await Dy_statistics({
					app_id: this.app_id,
					activity_id: this.$route.query.id,
				});
				this.statistics_data = res.data;
			} catch (e) {
				console.log(e);
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.heared {
	display: flex;
	justify-content: space-around;
	font-size: 18px;
	span {
		color: red;
	}
	margin: 20px;
}
.list {
	margin-top: 50px;
}
.turntable {
	width: 100%;
	padding: 15px 25px;
	height: 100%;
	overflow: auto;
	box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
	.el-input {
		width: 60%;
	}
	.screen {
		display: flex;
		flex-direction: row;
		margin-bottom: 25px;
		.el-button,
		.el-select,
		.el-input {
			margin-right: 10px;
		}
	}
	.tables {
		width: 100%;
		.headline {
			height: 28px;
			line-height: 28px;
			border-bottom: 1px solid #999;
			font-size: 16px;
			margin-bottom: 15px;
		}

		.el-table {
			margin-top: 15px;
			.awards {
				height: 60px;
				overflow: auto;
			}
		}

		.marginbtm15 {
			margin-bottom: 15px;
		}
	}
}
</style>
